import SvgArrowLeft from '@img/icons/arrow_left.svg';
import SvgArrowRight from '@img/icons/arrow_right.svg';
import DotPagination from '@stories/Components/Global/DotPagination/DotPagination';
import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Controls.styles';
// eslint-disable-next-line
const Controls = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    const step = React.useMemo(() => props.step ?? 1, [props.step]);
    return (React.createElement(S.Container, { ref: ref, className: props.className, "data-show-progress": carousel.maxIndex + 1 > 3, "data-item-amount": carousel.maxIndex + 1 > 6, "aria-label": props.paginationTitle },
        React.createElement(DotPagination, { count: carousel.maxIndex + 1, onChange: (index) => carousel.goToIndex(index), value: carousel.activeIndex }),
        React.createElement(S.ButtonArea, null,
            React.createElement(S.Button, { "aria-label": "Go to Previous Item", disabled: !props.wrap && carousel.activeIndex === 0, type: "button", onClick: (event) => {
                    event.preventDefault();
                    if (props.wrap) {
                        carousel.goToPrev();
                    }
                    else {
                        carousel.goToIndex(carousel.activeIndex - step);
                    }
                } },
                React.createElement(S.ButtonOutline, null),
                React.createElement(SvgArrowLeft, null)),
            React.createElement(S.Button, { "aria-label": "Go to Next Item", disabled: !props.wrap && carousel.activeIndex === carousel.maxIndex, type: "button", onClick: (event) => {
                    event.preventDefault();
                    if (props.wrap) {
                        carousel.goToNext();
                    }
                    else {
                        carousel.goToIndex(carousel.activeIndex + step);
                    }
                } },
                React.createElement(S.ButtonOutline, null),
                React.createElement(SvgArrowRight, null)))));
});
// Controls.displayName = 'Controls';
export default Controls;
